__turbopack_context__.v({
  "className": "herodisplay_9a4b98d8-module__PuUPIG__className",
});
